import styled from 'styled-components';

export const ReferralContestContainer = styled.div``

export const ReferralContestCard = styled.div`
    display: flex;
    flex-direction: column;
    margin: 15px;
    padding: 15px;
    background-color: ${({theme}) => theme.colors.primary};
    border: 1px solid ${({theme}) => theme.colors.link.text};
`